export const DEFAULT_PLAN_PRICING_GROUP = 'H'

export function usePlanPricingGroup(): string {
  // this hook can be used to a/b test different pricing groups or update to a new pricing group with feature flags
  return DEFAULT_PLAN_PRICING_GROUP
}
